class SearchDropdown {
  constructor() {
    this.searchDropdowns = document.querySelectorAll('.header__search-dropdown');
    this.searchTimeout = null;
    this.init();
  }

  init() {
    console.log('Found search dropdowns:', this.searchDropdowns.length);
    this.searchDropdowns.forEach((dropdown, index) => {
      console.log(`Setting up dropdown ${index + 1}:`, dropdown);
      this.setupDropdown(dropdown);
    });
    
    this.setupMenuHoverListener();
  }

  setupMenuHoverListener() {
    const mainMenu = document.querySelector('.list-menu--inline');
    if (mainMenu) {
      mainMenu.addEventListener('mouseenter', () => {
        this.closeAllSearchDropdowns();
      });
    }
  }

  closeAllSearchDropdowns() {
    this.searchDropdowns.forEach(dropdown => {
      const content = dropdown.querySelector('.search-dropdown-content');
      const suggestions = dropdown.querySelector('.search-suggestions');
      const suggestionsList = dropdown.querySelector('.search-suggestions-list');
      const popularCategories = dropdown.querySelector('.search-suggestions-footer');
      
      if (content && content.classList.contains('active')) {
        content.classList.remove('active');
        this.hideSuggestions(suggestions, suggestionsList);
        this.showPopularCategories(popularCategories);
      }
    });
  }

  setupDropdown(dropdown) {
    const toggle = dropdown.querySelector('.search-toggle');
    const content = dropdown.querySelector('.search-dropdown-content');
    const closeBtn = dropdown.querySelector('.search-dropdown-close');
    const input = dropdown.querySelector('.search-autocomplete');
    const suggestions = dropdown.querySelector('.search-suggestions');
    const suggestionsList = dropdown.querySelector('.search-suggestions-list');
    const form = dropdown.querySelector('.search-dropdown-form');
    const popularCategories = dropdown.querySelector('.search-suggestions-footer');
    
    console.log('Elements found:', {
      toggle: !!toggle,
      content: !!content,
      closeBtn: !!closeBtn,
      input: !!input,
      suggestions: !!suggestions,
      suggestionsList: !!suggestionsList,
      form: !!form,
      popularCategories: !!popularCategories
    });

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log('Search toggle clicked');
      if (content.classList.contains('hidden')) {
        content.classList.remove('hidden');
      }
      content.classList.toggle('active');
      console.log('Dropdown active:', content.classList.contains('active'));
      if (content.classList.contains('active')) {
        input.focus();
        this.showPopularCategories(popularCategories);
      }
    });

    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      content.classList.remove('active');
      this.hideSuggestions(suggestions, suggestionsList);
      this.showPopularCategories(popularCategories);
    });

    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
        content.classList.remove('active');
        this.hideSuggestions(suggestions, suggestionsList);
        this.showPopularCategories(popularCategories);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && content.classList.contains('active')) {
        content.classList.remove('active');
        this.hideSuggestions(suggestions, suggestionsList);
        this.showPopularCategories(popularCategories);
      }
    });

    input.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      if (query.length < 2) {
        this.hideSuggestions(suggestions, suggestionsList);
        this.showPopularCategories(popularCategories);
        return;
      }
      
      this.searchTimeout = setTimeout(() => {
        this.searchProducts(query, suggestions, suggestionsList, input, popularCategories);
      }, 500);
    });

    form.addEventListener('submit', (e) => {
      this.hideSuggestions(suggestions, suggestionsList);
      this.showPopularCategories(popularCategories);
    });
  }

  hideSuggestions(suggestions, suggestionsList) {
    if (suggestionsList) {
      suggestionsList.innerHTML = '';
    }
    suggestions.style.display = 'none';
  }

  showSuggestions(suggestions) {
    suggestions.style.display = 'block';
  }

  hidePopularCategories(popularCategories) {
    if (popularCategories) {
      popularCategories.style.display = 'none';
    }
  }

  showPopularCategories(popularCategories) {
    if (popularCategories) {
      popularCategories.style.display = 'block';
    }
  }

  async searchProducts(query, suggestions, suggestionsList, input, popularCategories) {
    if (!suggestionsList) {
      console.error('No se encontró .search-suggestions-list en el contenedor');
      return;
    }
    
    suggestionsList.innerHTML = '<div class="search-loading">Searching...</div>';
    this.showSuggestions(suggestions);
    this.hidePopularCategories(popularCategories);
    
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`);
      const data = await response.json();
      
      suggestionsList.innerHTML = '';
      
      if (data.resources && data.resources.results && data.resources.results.products) {
        const products = data.resources.results.products.slice(0, 4);
        if (products.length > 0) {
          const grid = document.createElement('ul');
          grid.className = 'search-suggestions-grid';
          products.forEach(product => {
            const productElement = this.createProductSuggestion(product, input, suggestions, suggestionsList, popularCategories);
            grid.appendChild(productElement);
          });
          suggestionsList.appendChild(grid);
          this.hidePopularCategories(popularCategories);
        } else {
          suggestionsList.innerHTML = '<div class="no-suggestions">No products found</div>';
          this.showPopularCategories(popularCategories);
        }
      } else {
        suggestionsList.innerHTML = '<div class="no-suggestions">No products found</div>';
        this.showPopularCategories(popularCategories);
      }
    } catch (error) {
      console.error('Error searching products:', error);
      suggestionsList.innerHTML = '<div class="no-suggestions">Error searching products</div>';
      this.showPopularCategories(popularCategories);
    }
  }

  createProductSuggestion(product, input, suggestions, suggestionsList, popularCategories) {
    const div = document.createElement('div');
    div.className = 'search-suggestion-item';
    
    let imageUrl = '/assets/no-image.png';
    if (product.featured_image) {
      imageUrl = typeof product.featured_image === 'string' 
        ? product.featured_image 
        : product.featured_image.src || product.featured_image.url;
    } else if (product.image) {
      imageUrl = typeof product.image === 'string' 
        ? product.image 
        : product.image.src || product.image.url;
    }
    console.log('SUGGESTED PRODUCT:', product);
    div.innerHTML = `
      <a href="${product.url}" class="search-suggestion-link">
        <div class="search-suggestion-image">
          <img src="${imageUrl}" alt="${product.title}" loading="lazy">
        </div>
        <div class="search-suggestion-content">
          <div class="search-suggestion-title bold-title">${product.title}</div> 
          <div class="search-suggestion-title">
            ${window.theme.cart_currency_symbol} ${product.price}
            ${(() => {
              let color = '';
              if (product.tags && Array.isArray(product.tags)) {
                const colorTag = product.tags.find(tag => tag.startsWith('color_'));
                if (colorTag) {
                  color = colorTag.replace('color_', '');
                }
              }
              return color ? ` | <span class='search-suggestion-color'>${color}</span>` : '';
            })()}
          </div>
        </div>
      </a>
    `;
    
    // Handle click on suggestion
    div.addEventListener('click', (e) => {
      e.preventDefault();
      input.value = product.title;
      this.hideSuggestions(suggestions, suggestionsList);
      this.showPopularCategories(popularCategories);
      window.location.href = product.url;
    });
    
    return div;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SearchDropdown();
}); 